import { useEffect, useState } from "react";
import { BrandLogo } from "@/components/iv/BrandLogo";
import { AuthControls } from "@/components/iv/AuthControls";
import { CaseStudySelect } from "@/components/iv/CaseStudySelect";
import { useApp } from "@/context/AppContext";
import { QuotaPill } from "@/components/iv/QuotaPill";

const AdminLink = () => {
  const { user } = useApp();
  if (user?.role !== "admin") return null;
  return <a href="/admin" className="rounded-full border border-white/10 px-3 py-1 text-xs font-semibold text-slate-300 hover:text-white" data-testid="admin-link">Admin</a>;
};

const useScrolled = (threshold = 48) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return scrolled;
};

export const Header = () => {
  const compact = useScrolled();
  return (
    <header className="sticky top-0 z-40 border-b border-white/[0.06] bg-[#060913]/80 backdrop-blur-xl" data-testid="site-header" data-compact={compact ? "true" : "false"}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className={`flex items-center justify-between gap-3 transition-[padding] duration-300 sm:py-3 ${compact ? "py-1.5" : "py-2.5"}`}>
          <BrandLogo compact={compact} />
          <AuthControls />
        </div>
        {/* Mobile: row 2 collapses on scroll; always visible from sm up */}
        <div className={`flex flex-wrap items-center gap-2 overflow-hidden transition-[max-height,opacity,padding] duration-300 sm:max-h-none sm:overflow-visible sm:pb-3 sm:opacity-100 ${
          compact ? "max-h-0 pb-0 opacity-0" : "max-h-40 pb-2.5 opacity-100"
        }`} data-testid="header-controls-row">
          <CaseStudySelect />
          <QuotaPill />
          <AdminLink />
        </div>
      </div>
    </header>
  );
};
